/**
 * Логирование виджета: в production по умолчанию выключено.
 * Включается при window.LarteChat.debug === true или в dev-сборке Vite.
 */

function isVerbose(): boolean {
  try {
    if (import.meta.env.DEV) return true;
  } catch {
    /* UMD вне Vite */
  }
  if (typeof window !== 'undefined' && window.LarteChat?.debug === true) {
    const host = window.location?.hostname || '';
    // В production на внешних доменах принудительно подавляем debug-логи,
    // чтобы интеграция виджета не засоряла консоль клиента.
    if (host === 'localhost' || host === '127.0.0.1') return true;
  }
  return false;
}

export const chatLogger = {
  log: (...args: unknown[]) => {
    if (isVerbose()) console.log(...args);
  },
  info: (...args: unknown[]) => {
    if (isVerbose()) console.info(...args);
  },
  debug: (...args: unknown[]) => {
    if (isVerbose()) console.debug(...args);
  },
  warn: (...args: unknown[]) => {
    if (isVerbose()) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    if (isVerbose()) console.error(...args);
  },
  /** Редкие случаи: некорректная установка, падение React */
  alwaysError: (...args: unknown[]) => {
    console.error(...args);
  },
};
